import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-down",
  "use": "icon-down-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-down\"><path d=\"M512 938.666667a52.92 52.92 0 0 0 45.666667-25.78l373.28-618.666667a53.333333 53.333333 0 0 0-45.666667-80.886667H138.72a53.333333 53.333333 0 0 0-45.666667 80.886667l373.28 618.666667A52.92 52.92 0 0 0 512 938.666667z m405.333333-810.666667H106.666667a21.333333 21.333333 0 0 1 0-42.666667h810.666666a21.333333 21.333333 0 0 1 0 42.666667z\" fill=\"#ffffff\" p-id=\"4387\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol